import React, { useEffect, useMemo, useState } from 'react';
import { InputContainer, Search } from 'finform';

/**
 * Селект портфеля — по той же схеме, что InvestSelectCurrency («Валюта актива»).
 */
const InvestSelectPortfolio = ({
  userTabs = [],
  investPortfolio: portfolioProp,
  handleSelectPortfolio,
}) => {
  const options = useMemo(
    () => [{ id: 'all', name: 'Все' }, ...userTabs.map((tab) => ({ id: tab.id, name: tab.title }))],
    [userTabs]
  );

  const [portfolio, setPortfolio] = useState(portfolioProp);
  const [portfolioSearch, setPortfolioSearch] = useState(portfolioProp?.name ?? 'Все');

  useEffect(() => {
    if (!portfolioProp) {
      return;
    }
    setPortfolio(portfolioProp);
    setPortfolioSearch(portfolioProp.name ?? 'Все');
  }, [portfolioProp]);

  if (userTabs.length <= 1) {
    return null;
  }

  const portfolioValue =
    portfolio?.id == null ? { id: null, name: portfolio?.name ?? 'Все' } : portfolio;

  const handleSearch = (search) => {
    setPortfolioSearch(search);

    const searchItem = options.find((item) => item.name === search);
    if (searchItem) {
      setPortfolioSearch(searchItem.name);
      const id = searchItem.id === 'all' ? null : searchItem.id;
      setPortfolio({ id, name: searchItem.name });
    }
  };

  const handleSelect = (item) => {
    if (item) {
      const id = item.id === 'all' ? null : item.id;
      handleSelectPortfolio({ id, name: item.name });
      setPortfolioSearch(item.name);
    } else {
      handleSelectPortfolio(null);
      setPortfolioSearch('');
    }
  };

  return (
    <InputContainer
      style={{
        maxWidth: '200px',
        flexShrink: 0,
      }}
    >
      <Search
        placeholder="Портфели"
        id="portfolio-select"
        options={options}
        value={portfolioValue}
        search={portfolioSearch}
        onSearch={handleSearch}
        onChange={handleSelect}
      />
    </InputContainer>
  );
};

export default React.memo(InvestSelectPortfolio);
